<div class="admin-content">
  <cei-admin-page-cabecalho titulo="Detalhes da pessoa / usuário" [rotaVoltar]="'/admin/pessoas'" />
  @if (record(); as item) {
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <div class="admin-pessoa-detail">
        <div class="admin-pessoa-detail__foto">
          <cei-user-avatar
            [fotoSourceUrl]="item.foto_url"
            [cacheKey]="'admin-detail-' + item.id"
            [fallbackToSessionProfile]="false"
          />
        </div>
        <table class="admin-detail-table admin-pessoa-detail__tabela">
          <tbody>
            <tr>
              <th scope="row">ID</th>
              <td>{{ item.id }}</td>
            </tr>
            <tr>
              <th scope="row">Nome</th>
              <td>{{ item.nome }}</td>
            </tr>
            <tr>
              <th scope="row">CPF</th>
              <td>{{ item.cpf | ceiDocumentoFiscal }}</td>
            </tr>
            <tr>
              <th scope="row">Login</th>
              <td>{{ item.usuario?.login ?? '—' }}</td>
            </tr>
            <tr>
              <th scope="row">E-mail</th>
              <td>{{ item.usuario?.email ?? '—' }}</td>
            </tr>
            <tr>
              <th scope="row">Ativo</th>
              <td>{{ item.usuario?.is_active ? 'Sim' : 'Não' }}</td>
            </tr>
            <tr>
              <th scope="row">Staff</th>
              <td>{{ item.usuario?.is_staff ? 'Sim' : 'Não' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </cei-panel>
    <div class="admin-content__actions" [routerLink]="editLink(item)">
      <cei-button type="button">Editar</cei-button>
    </div>
  } @else {
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <p class="admin-detail-empty">Registro não encontrado.</p>
    </cei-panel>
  }
</div>
